"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeHTML = void 0;

var escapeHTML = function escapeHTML(source) {
  return source.replace(/["&'/<>]/g, function (char) {
    return {
      '"': "&quot;",
      "&": "&amp;",
      "'": "&#39;",
      "/": "&#47;",
      "<": "&lt;",
      ">": "&gt;"
    }[char];
  });
};

exports.escapeHTML = escapeHTML;